import Ajax from './ajax';
import Log from './log';
import Cookie from 'js-cookie';
import ErrorService from './error-service';

let blockCrawlerCache;

function blockCrawler() {
  if (blockCrawlerCache !== undefined) return blockCrawlerCache;

  if (
    typeof window === 'undefined' ||
    typeof window.navigator === 'undefined' ||
    typeof window.navigator.userAgent === 'undefined'
  ) {
    blockCrawlerCache = false;
  } else {
    let ua = window.navigator.userAgent.toLowerCase();
    blockCrawlerCache = ua.includes('semrush') || ua.includes('googlebot');
  }

  return blockCrawlerCache;
}

function detectScreenSize() {
  if (typeof window === 'undefined') return {};

  return {
    screen_width: window.innerWidth,
    screen_height: window.innerHeight,
  };
}

function track(event_type, data) {
  if (blockCrawler()) {
    return;
  }

  const eventData = {
    event_type,
    data,
    benable_user: Cookie.get('benable-user') || false,
    ...detectScreenSize(),
  };

  let resp = Ajax.post({
    withErrorHandling: false,
    url: '/events',
    data: eventData,
  }).catch((err) => {
    let msg = `[ERROR] Event: ${event_type} | ${JSON.stringify(data)} | status: ${err.status}`;

    ErrorService.capture(msg);
    Log.info(msg, true);
  });

  return resp;
}

export default {
  track: track,
};
